// @mui
import { Stack, Typography } from '@mui/material';

import IconButton from '@mui/material/IconButton';
// routes
import { useState } from 'react';
import Iconify from 'src/components/iconify';
import MenuPopover from 'src/components/menu-popover';
import { translateKey } from 'src/locales/translate';


// ----------------------------------------------------------------------

type DobInfoPopoverProps = {
  copy?: string;
};

export default function DobInfoPopover({ copy }: DobInfoPopoverProps) {
  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <IconButton
        aria-label="info"
        id="button"
        aria-haspopup="true"
        onClick={handleOpenPopover}
        edge="end"
      >
        <Iconify icon={'eva:info-outline'} />
      </IconButton>
      <MenuPopover
        open={openPopover}
        onClose={handleClosePopover}
        arrow="bottom-right"
        disabledArrow
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      >
        <Stack sx={{ p: 1, maxWidth: 350 }}>
          <Typography variant="body1">{translateKey("hardcoded.do_czego_wykorzystujemy_date_urodzenia")}</Typography>
          <Typography variant="body2">
            {copy ||
              translateKey("hardcoded.data_urodzenia_pozwala_nam_lepiej_dopasowac_nasze_uslugi")}
          </Typography>
        </Stack>
      </MenuPopover>
    </>
  );
}
